'use client'
import styled from "styled-components";
import {hover} from "@/styles/globalStyleVars";
import {Col, Container, Row} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import {useEffect, useState} from "react";




const MyComponent = ({ data }) => {
    const [isWideScreen, setIsWideScreen] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsWideScreen(window.innerWidth > 1680);
        };

        // Set initial screen size
        checkScreenSize();

        // Update screen size on resize
        window.addEventListener('resize', checkScreenSize);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    return (
        <StyledComponent className={"transaction-list pt-100 pb-100 watch-section"} id={'transaction-list'}>
            <Container>
                <Row>
                    {
                        data?.posts?.list && data?.posts?.list?.length > 0 &&
                        data.posts.list.map((element, index) => {
                            return (
                                <Col md={isWideScreen ? 4 : 6} key={index}>
                                    <div className="transaction-list-item">
                                        <h4 className={'cat'}>{element?.data?.subtitle}</h4>
                                        <img src={element?.images?.[0]?.full_path} alt=""/>
                                        <h4 className={'name'}>{element?.data?.title}</h4>
                                        <p className={'text'}>{reactHtmlParser(element?.data?.description)}</p>
                                        <p className={'year'}>{element?.data?.short_desc}</p>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>
        </StyledComponent>
    );
};
const StyledComponent = styled.section`
    background-color: #f9f9f9;
    .transaction-list-item{
        padding: 65px 30px;
        background-color: #ffffff;
        border-radius: 5px;
        height: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        .cat{
            font-size: 18px;
            line-height: 24px;
            font-weight: 500;
            color: ${hover};
            margin-bottom: 20px;
        }
        img{
            margin-bottom: 20px;
            height: 100px;
        }
        .name{
            font-size: 24px;
            line-height: 32px;
            font-weight: 500;
            color: #3C3C3B;
            margin-bottom: 20px;
        }
        .text{
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: rgba(60,60,59,0.75);
            margin-bottom: 45px;
        }
        .year{
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: ${hover};
            position: absolute;
            bottom: 65px;
            left: 50%;
            transform: translateX(-50%);

        }
        h4,p{
            text-align: center;
        }
        @media(max-width: 767px){
            padding: 30px 15px;
            .year{
                bottom: 30px;
            }
        }
    }
    .col-md-6{
        margin-bottom: 30px;
    }
    .col-md-4{
        margin-bottom: 30px;
    }
    @media(max-width: 767px){
        br{
            display: none;
        }
        .transaction-list-item{
            height: unset;
        } 
    }
`;

export default MyComponent;
